import { isGlobalSearchCollection } from "../../search";

const isGlobalSearch = (collection: string) =>
    isGlobalSearchCollection(collection);

export default isGlobalSearch;
